import React from "react";

const SkeletonSlot = () => {
  return (
    <table className="w-full border-collapse border border-gray-300">
      <thead>
        <tr className="bg-gray-300 animate-pulse">
          <th className="font-medium border p-2 w-20 rounded-tl-md">&nbsp;</th>
          <th className="font-medium border p-2">&nbsp;</th>
          <th className="font-medium border p-2">&nbsp;</th>
          <th className="font-medium border p-2">&nbsp;</th>
          <th className="font-medium border p-2 w-40 rounded-tr-md">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 5 }).map((_, index) => (
          <tr key={index} className="border animate-pulse">
            <td className="border p-2">
              <div className="h-4 bg-gray-300 rounded w-8 mx-auto"></div>
            </td>
            <td className="border p-2">
              <div className="h-4 bg-gray-300 rounded w-24 mx-auto"></div>
            </td>
            <td className="border p-2">
              <div className="h-4 bg-gray-300 rounded w-16 mx-auto"></div>
            </td>
            <td className="border p-2">
              <div className="h-4 bg-gray-300 rounded w-16 mx-auto"></div>
            </td>
            <td className="border px-2">
              <div className="h-6 bg-gray-300 rounded w-24 mx-auto"></div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SkeletonSlot;